import React from 'react';
import { isMoveToManagementRouterEnabled } from '@helpcenter/feature-flags';
import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';
import type { Route } from 'react-resource-router';
import { withRouter } from 'react-resource-router';
import { JiraAdminPermissionWrapper } from 'utils/routes';

const AsyncHelpCenterEditDetailsPageOld = withAsync({
    loader: lazyForPaint(() =>
        import(/* webpackChunkName: "async-help-center-edit-details-page" */ '@atlassian/help-centers-management').then(
            ({ HelpCenterEditDetails }) => HelpCenterEditDetails
        )
    ),
    LoadingSkeleton: () => null,
});

const AsyncHelpCenterManageProjectsPageOld = withAsync({
    loader: lazyForPaint(() =>
        import(/* webpackChunkName: "async-help-center-manage-projects-page" */ '@atlassian/admin-layout').then(
            ({ HelpCenterManageProjects }) => HelpCenterManageProjects
        )
    ),
    LoadingSkeleton: () => null,
});

const AsyncHelpCenterManageCustomPagesPageOld = withAsync({
    loader: lazyForPaint(() =>
        import(/* webpackChunkName: "async-help-center-manage-pages-page" */ '@atlassian/admin-layout').then(
            ({ HelpCenterManagePages }) => HelpCenterManagePages
        )
    ),
    LoadingSkeleton: () => null,
});

const AsyncHelpCenterEditDetailsPage = withAsync({
    loader: lazyForPaint(() =>
        import(
            /* webpackChunkName: "async-help-center-edit-details-page" */ '@atlassian/help-centers-management/src/ui/edit-helpcenter/index'
        ).then(({ HelpCenterEditDetails }) => HelpCenterEditDetails)
    ),
    LoadingSkeleton: () => null,
});

const AsyncHelpCenterManageProjectsPage = withAsync({
    loader: lazyForPaint(() =>
        import(
            /* webpackChunkName: "async-help-center-manage-projects-page" */ '@atlassian/admin-layout/src/ui/manage-projects/index'
        ).then(({ HelpCenterManageProjects }) => HelpCenterManageProjects)
    ),
    LoadingSkeleton: () => null,
});

const AsyncHelpCenterManageCustomPagesPage = withAsync({
    loader: lazyForPaint(() =>
        import(
            /* webpackChunkName: "async-help-center-manage-pages-page" */ '@atlassian/admin-layout/src/ui/manage-pages/index'
        ).then(({ HelpCenterManagePages }) => HelpCenterManagePages)
    ),
    LoadingSkeleton: () => null,
});

export const helpcenterEditRoute: Route = {
    name: 'edit-details',
    path: isMoveToManagementRouterEnabled() ? '/:helpcenterId/details' : '/edit-details',
    exact: true,
    component: withRouter(() => (
        <JiraAdminPermissionWrapper>
            {isMoveToManagementRouterEnabled() ? (
                <AsyncHelpCenterEditDetailsPage />
            ) : (
                <AsyncHelpCenterEditDetailsPageOld />
            )}
        </JiraAdminPermissionWrapper>
    )),
};

export const helpcenterManageProjectsRoute: Route = {
    name: 'manage-projects',
    path: isMoveToManagementRouterEnabled() ? '/:helpcenterId/projects' : '/manage-projects',
    exact: true,
    component: withRouter(() => (
        <JiraAdminPermissionWrapper>
            {isMoveToManagementRouterEnabled() ? (
                <AsyncHelpCenterManageProjectsPage />
            ) : (
                <AsyncHelpCenterManageProjectsPageOld />
            )}
        </JiraAdminPermissionWrapper>
    )),
};

export const helpcenterManageCustomPagesRoute: Route = {
    name: 'manage-pages',
    path: isMoveToManagementRouterEnabled() ? '/:helpcenterId/pages' : '/manage-pages',
    exact: true,
    component: withRouter(() => (
        <JiraAdminPermissionWrapper>
            {isMoveToManagementRouterEnabled() ? (
                <AsyncHelpCenterManageCustomPagesPage />
            ) : (
                <AsyncHelpCenterManageCustomPagesPageOld />
            )}
        </JiraAdminPermissionWrapper>
    )),
};
